export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9071.b7f5b738.jpg";